import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { styled, withStyles } from '@material-ui/core/styles';


export const FormBox = styled(Box)({
  width: '100%',
  maxWidth: '700px',
  padding: '0px',
  marginTop: '30px'
});

export const InstallBox = styled(Box)({
  fontSize: '13px',
  width: '100%',
  // minHeight: '35px',
  padding: '3px 0px 3px 0px',
  borderBottom: '1px solid #d9d9d9',
  '& .react-ip-input': {
    backgroundColor: '#fff',
    padding: '0px 6px 0px 6px',
    fontSize: '13px',
    width: '150px'
  },
  '& .react-ip-input__item': {
    padding: '0px',
    color: '#004057',
    /*background-color: red;*/
  },
  '& .react-ip-input input': {
    padding: '0px',
    width: '30px',
    height: '30px',
    color: 'inherit'
  },
  '& .react-ip-input i': {
    color: 'inherit'
  }
});

export const Header = styled(Box)({
  display: 'inline-flex',
  fontSize: '22px',
  fontWeight: 'normal',
  textTransform: 'capitalize',
  letterSpacing: '1.2px',
  marginBottom: '15px',
});

export const Label = styled(Typography)({
  fontSize: '13px',
  fontWeight: '100%',
  textTransform: 'capitalize',
  marginTop: '1px',
  minHeight: '20px',
});

export const ItemBox = withStyles({
  root: {
    fontSize: '13px',
    width: '100%',
    // minHeight: '20px',
    padding: '3px 0px 3px 0px',
    borderBottom: '1px solid #d9d9d9',
  },
})(Box);

export const Title = withStyles({
  root: {
    fontSize: '16px',
    fontWeight: '100%',
    textTransform: 'capitalize',
    letterSpacing: '0.8px',
  },
})(props => <Typography {...props}>{props.label}</Typography>);

export const Value = withStyles({
  root: {
    fontSize: '13px',
    fontWeight: '100%',
    textTransform: 'none',
    letterSpacing: '0.8px',
    marginTop: '1px',
    minHeight: '20px',
  },
})(props => <Typography {...props}>{props.label}</Typography>);
